import { resolve } from '@/core/di';
import { TaskListApi } from './TaskListApi';

export { TaskListApi };
export const taskListApi = (): TaskListApi => resolve(TaskListApi);
